import React from 'react';
import { ShippingMethodContract } from '../../../types/ShippingMethods';
import ShippingMethodItem from '../ShippingMethodItem';
import { GroupNames } from '../../../utils/constants';

export const ShippingMethodListTestId = 'ShippingMethodList-input';

export type ShippingMethodListProps = {
  shippingMethods: ShippingMethodContract[];
  selectedShippingMethod?: ShippingMethodContract | null;
  formattedCurrencySymbol: string;
  onShippingMethodChanged?: (shippingMethodId: number) => void;
};

const ShippingMethodList: React.FC<ShippingMethodListProps> = ({
  shippingMethods,
  formattedCurrencySymbol,
  onShippingMethodChanged,
  selectedShippingMethod,
}: ShippingMethodListProps) => {
  const handleShippingMethodChanged = (shippingMethodId: string): void => {
    onShippingMethodChanged?.(Number.parseInt(shippingMethodId, 10));
  };
  return (
    <div
      className="flex flex-col p-2 w-full mb-6"
      data-testid={ShippingMethodListTestId}
    >
      <ul className="flex flex-col divide divide-y rounded-md border checkout-panel-border">
        {shippingMethods.map(shippingMethod => (
          <ShippingMethodItem
            key={shippingMethod.id}
            shippingMethod={shippingMethod}
            formattedCurrencySymbol={formattedCurrencySymbol}
            name={GroupNames.SHIPPING_METHOD_GROUP_NAME}
            onShippingMethodChanged={handleShippingMethodChanged}
            selectedShippingMethod={selectedShippingMethod}
          />
        ))}
      </ul>
    </div>
  );
};
export default ShippingMethodList;
